export const formatPhone = (phone: string) => {
  if (!phone) return phone;

  let strippedPhone = phone.split(/[\s+()-]+/).join('');

  if (strippedPhone.length > 11 && strippedPhone.startsWith('55')) {
    strippedPhone = strippedPhone.replace('55', '');
  }

  if (strippedPhone.length === 11) {
    return `(${strippedPhone.slice(0, 2)}) ${strippedPhone.slice(2, 7)}-${strippedPhone.slice(7, 11)}`;
  }

  return `(${strippedPhone.slice(0, 2)}) ${strippedPhone.slice(2, 6)}-${strippedPhone.slice(6, 10)}`;
};

export const normalizePhoneFromInput = (value: string) => {
  const unmaskedPhone = `+${value.replace(/\D/g, '')}`;
  const isMissingNine = unmaskedPhone.slice(5).length === 8 || unmaskedPhone[5] !== '9';

  if (!isMissingNine) return unmaskedPhone;

  return `${unmaskedPhone.slice(0, 5)}9${unmaskedPhone.slice(5)}`;
};
